<template>
    <div class="aside relative">
        <!-- 顶部 -->
        <div class="show">
            <div class="aside_top flex">
            <span @click="goHome()" style="cursor: pointer;">BestVpns </span>
        </div>
        </div>
        <!-- 主题导航 -->
        <div class="aside_main">
            <div v-for="data in  asideData" :key="data.id">
                <div v-if="data.type === 'item'"
                    :class="data.path === this.$route.path ? 'aside_item_active' : 'aside_item_normal'"
                    @click="clickAside(data)">
                    <div
                        style="margin-right: 10px;display: flex;justify-content: center;align-items: center;align-content: center;">
                        <img style="width:18px;height:18px" :src="data.icon" />
                    </div>
                    <div style="display: flex;justify-content: center;align-items: center;">{{ $t(data.name) }}</div>
                </div>
                <div v-else class="aside_title">
                    <span>{{ $t(data.name) }}</span>
                </div>
            </div>
        </div>
        <div class="absolute position-b-0 title15">
            BestVpns  {{version}}
        </div>
    </div>
</template>
<script>
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex';
export default {
    setup() {
        const { t } = useI18n()
        const store = useStore();
        return {t ,store}
    },
    data() {
        return {
            asideData: [
                {
                    id: 1,
                    type: 'item',
                    name: 'aside.dash_board',
                    path: '/pannel',
                    icon: require('../assets/img/plane.png')
                },
                {
                    id: 2,
                    type: 'item',
                    name: 'aside.knowledge_base',
                    path: '/document',
                    icon: require('../assets/img/document.png')
                },
                {
                    id: 3,
                    type: 'title',
                    name: 'aside.subscribe',
                    icon: ''
                },
                {
                    id: 4,
                    type: 'item',
                    name: 'aside.purchase_subscription',
                    path: '/shop',
                    icon: require('../assets/img/bag.png')
                },
                {
                    id: 5,
                    type: 'item',
                    name: 'aside.node_status',
                    path: '/state',
                    icon: require('../assets/img/check.png')
                },
                {
                    id: 6,
                    type: 'title',
                    name: 'aside.finance',
                    icon: ''
                },
                {
                    id: 7,
                    type: 'item',
                    name: 'aside.my_order',
                    path: '/orders',
                    icon: require('../assets/img/list.png')
                },
                // {
                //     id: 8,
                //     type: 'item',
                //     name: '我的邀请',
                //     path: '/invite',
                //     icon: require('../assets/img/people.png')
                // },
                {
                    id: 9,
                    type: 'title',
                    name: 'aside.user',
                    icon: ''
                },
                {
                    id: 10,
                    type: 'item',
                    name: 'header.user_enter',
                    path: '/person',
                    icon: require('../assets/img/person.png')
                },
                // {
                //     id: 11,
                //     type: 'i tem',
                //     name: '我的工单',
                //     path: '/help',
                //     icon: require('../assets/img/help.png')
                // },
                // {
                //     id: 12,
                //     type: 'item',
                //     name: '流量明细',
                //     path: '/flow',
                //     icon: require('../assets/img/flow.png')
                // },
            ],
            version:window.ipConfig.version
        }
    },
    methods: {
        clickAside(data) {
            this.$router.push(data.path);
            this.store.commit('updateActiveName', data.name);
            this.store.commit('updateActivePath', data.path);
            this.$router.push(data.path);
            this.$emit("asideCose","");
        },
        goHome(){
            this.$router.push('/login');
        }
    },
    created() {
    }
}
</script>
<style scoped>
.aside {
    height: 100%;
    width: 100%;
}

.aside_top {
    height: 52px;
    width: 100%;
    background-color: #40a0ffc4;
    display: flex;
    justify-content: center;
    align-content: center;
    color: rgb(241, 241, 241);
    font-size: 20px;
    font-weight: 700;
    align-items: center;

}

.aside_main {
    padding: 18px;
}

.aside_item_normal {
    height: 20px;
    padding: 8px 10px;
    color: black;
    display: flex;
    font-size: 14px;
    border: 1px solid transparent;
    border-radius: 5px;
    cursor: pointer;
}

.aside_item_normal:hover {
    height: 20px;
    padding: 8px 10px;
    color: black;
    display: flex;
    font-size: 14px;
    background-color: #EBEBEB;
    border: 1px solid #EBEBEB;
    border-radius: 5px;
    cursor: pointer;
}

.aside_item_active {
    height: 20px;
    padding: 8px 10px;
    color: black;
    display: flex;
    font-size: 14px;
    background-color: #EBEBEB;
    border: 1px solid #EBEBEB;
    border-radius: 5px;
    cursor: pointer;
}

.aside_title {
    width: 204px;
    height: 19.5px;
    padding: 28px 0px 4px 10px;
    font-size: 13px;
    color: #869099;
}
</style>